/* eslint-disable */

<template>
  <div class="photo" @dragover.prevent @drop.stop.prevent>
    <div v-show="currentView == -1" class="photo__image-box" id="dropZone" @drop.stop.prevent="onDrop">
      <p class="photo__uploadmsg">{{ $t("photo.uploadMsg") }}</p>
    </div>
    <div v-for="(cab, index) in tBarCod" :key="cab" :id="cab">
      <div v-show="currentView === index">
        <div class="photo__label-box">
          <h2 class="photo__label">{{ $t("photo.scopableLabel") }}</h2>
          <span>{{ currentView + 1 }}/{{ tBarCod.length }}</span>
        </div>
        <div class="photo-box">
          <div class="photo__itemlist photo__itemlist-scopable">
            <div class="photo__overlay-container" v-for="photo in scopablePhotos(cab)" :key="photo.name">
              <div class="photo__item-box">
                <img class="photo__item-thumbnail" :src="createPhotoUrl(photo)" />
                <label class="photo__item-label">{{getPhotoName(photo)}}</label>
              </div>
              <div class="photo__overlay-content">
                <div class="photo__overlay-toolbox">
                  <svg class="table__icon table__icon--medium" @click="currentPhoto = photo; showPhotoScopable(true);">
                    <use href="@/assets/sprite.svg#icon-sitemap"></use>
                  </svg>
                  <svg class="table__icon table__icon--medium" @click="currentPhoto = photo; showImageColorPicker(true);">
                    <use href="@/assets/sprite.svg#icon-pencil"></use>
                  </svg>
                  <svg class="table__icon table__icon--medium" @click="deletePhoto(photo)">
                    <use href="@/assets/sprite.svg#icon-trash"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tArticles[currentView]" class="photo__infos-box">
            <div class="u-row1 photo__infos-label">{{ $t("photo.infos.barCode") }}</div>
            <div class="u-row1">{{ tBarCod[currentView] }}</div>
            <div class="u-row2 photo__infos-label">{{ $t("photo.infos.color") }}</div>
            <div class="u-row2">
              {{ tArticles[currentView]["supplierColorName"] }}
              ({{ tArticles[currentView]["supplierColorCode"] }})
            </div>
            <div class="u-row3 photo__infos-label">{{ $t("photo.infos.colorCode") }}</div>
            <div class="u-row3 photo__infos-color">
              <input key="myinput" class="photo__infos-colorpicker" type="color" v-model="tHexaColorCode[currentView]" />
              <span>{{ getHexaColorCode(currentView) }}</span>
            </div>
            <div class="u-row4 photo__infos-label">{{ $t("photo.infos.colorFilter") }}</div>
            <div class="u-row4">
              <select class="photo__infos-filter" name="filterColor" v-model="tFilterColorSelected[currentView]">
                <option disabled value="">{{ $t("photo.infos.selectColorFilter") }}</option>
                <option v-for="color in tFilterColor" :key="color.code" :value="color.code">{{ color.labels.fr_FR }}</option>
              </select>
            </div>
            <div class="u-row5 photo__infos-export">
              <button class="photo__infos-export-btn" @click="exportAll()">
                <svg class="photo__infos-export-icon">
                  <use href="@/assets/sprite.svg#icon-upload3"></use>
                </svg>
                {{ $t("photo.btn") }}
              </button>
            </div>
	    <div class="u-row6 photo__infos-export">
	      <input class="userpopup__checkbox-button" type="checkbox" value="checkbox_marque_propre" id="checkbox_marque_propre" v-model="marquePropreChecked" @change="if(edisacChecked && marquePropreChecked) edisacChecked=false">
	      <label class="userpopup__checkbox-label u-pointer" for="checkbox_marque_propre">Uniquement pour la marque propre</label>
	    </div>
	    <div class="u-row7 photo__infos-export">
	      <input class="userpopup__checkbox-button" type="checkbox" value="checkbox_edisac" id="checkbox_edisac" v-model="edisacChecked" @change="if(marquePropreChecked && edisacChecked) marquePropreChecked=false">
	      <label class="userpopup__checkbox-label u-pointer" for="checkbox_edisac">Uniquement pour les sites edisac</label>
	    </div>
          </div>
        </div>
        <h2 class="photo__label">{{ $t("photo.noScopableLabel") }}</h2>
        <div class="photo__itemlist photo__itemlist-noscopable">
          <div class="photo__overlay-container" v-for="photo in noscopablePhotos(cab)" :key="photo.name">
            <div class="photo__item-box">
              <img class="photo__item-thumbnail" :src="createPhotoUrl(photo)" />
              <label class="photo__item-label">{{ getPhotoName(photo) }}</label>
            </div>
            <div class="photo__overlay-content">
              <div class="photo__overlay-toolbox">
                <svg class="table__icon table__icon--medium" @click="currentPhoto = photo; showImageColorPicker(true);">
                  <use href="@/assets/sprite.svg#icon-pencil"></use>
                </svg>
                <svg class="table__icon table__icon--medium" @click="deletePhoto(photo)">
                  <use href="@/assets/sprite.svg#icon-trash"></use>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="popup">
      <ImageColorPicker v-if="getShowImageColorPicker" :photo="currentPhoto" @changeColor="changeColor"></ImageColorPicker>
      <PhotoSetScopable v-if="getShowPhotoScopable" :brand="tArticles[currentView]['brand']" :photo="currentPhoto" @changeSites="changeSites"></PhotoSetScopable>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { HTTP_CLIENT, HTTP_PIM, HTTP_PIM_IMG } from '@/axios-wrapper'
import { toastMixin } from '@/components/Mixins/Toast'
import { dialogboxMixin } from '@/components/Mixins/Dialogbox'
import ImageColorPicker from '@/views/popup/ImageColorPicker.vue'
import PhotoSetScopable from '@/views/popup/PhotoSetScopable.vue'

const { mapGetters, mapMutations } = createNamespacedHelpers('photo')

export default {
  data: function () {
    return {
      tPhotosDropped: [],
      tPhotosScopable: [],
      tPhotosNoScopable: [],
      tBarCod: [],
      tArticles: [],
      tHexaColorCode: [],
      tFilterColorSelected: [],
      tFilterColor: {},
      tErrPhotosUploadedToAkeneo: [],
      tErrPhotosUploadedToExopera: [],
      tEanCode: [],
      productFields: 'PhotoVuePorte1,Atout1Image,Atout2Image,Atout3Image,PhotoYoutube,AtoutSpecialImage',
      currentView: -1,
      previousView: -1,
      currentPhoto: '',
      errColorUploaded: false,
      marquePropreChecked: false,
      edisacChecked: false,
      siteList: [
        { site: 'Edisac.com', id: 'COM', checked: true },
        { site: 'Edisac.be', id: 'BE', checked: true },
        { site: 'Edisac.nl', id: 'NL', checked: true },
        { site: 'Woomen.fr', id: 'Woomen', checked: false },
        { site: 'Cameleon.eu', id: 'Cameleon', checked: false },
        { site: 'Etrier.fr', id: 'Etrier', checked: false }
      ],
      dialogBoxDelete: {
        title: this.$t('dialog.photo.delete.title'),
        content: this.$t('dialog.photo.delete.content'),
        cancelAction: this.$t('dialog.photo.delete.cancelAction'),
        confirmAction: this.$t('dialog.photo.delete.confirmAction')
      },
      dialogBoxDeleteBarCode: {
        title: this.$t('dialog.photo.barcode.delete.title'),
        content: this.$t('dialog.photo.barcode.delete.content'),
        cancelAction: this.$t('dialog.photo.barcode.delete.cancelAction'),
        confirmAction: this.$t('dialog.photo.barcode.delete.confirmAction')
      },
      dialogBoxInputErrors: {
        title: this.$t('dialog.photo.error.titleInput'),
        content: '',
        cancelAction: this.$t('dialog.photo.error.cancelAction'),
        confirmAction: this.$t('dialog.photo.error.confirmAction')
      },
      dialogBoxOutputAkeneoErrors: {
        title: this.$t('dialog.photo.error.titleAkeneo'),
        content: '',
        cancelAction: this.$t('dialog.photo.error.cancelAction'),
        confirmAction: this.$t('dialog.photo.error.confirmAction')
      },
      dialogBoxOutputExoperaErrors: {
        title: this.$t('dialog.photo.error.titleExopera'),
        content: '',
        cancelAction: this.$t('dialog.photo.error.cancelAction'),
        confirmAction: this.$t('dialog.photo.error.confirmAction')
      },
      dialogBoxOverwrite: {
        title: this.$t('dialog.photo.overwrite.title'),
        content: this.$t('dialog.photo.overwrite.content'),
        cancelAction: this.$t('dialog.photo.overwrite.cancelAction'),
        confirmAction: this.$t('dialog.photo.overwrite.confirmAction')
      },
      dialogBoxColorsErrors: {
        title: this.$t('dialog.photo.errorExport.titleInput'),
        content: this.$t('dialog.photo.errorExport.content'),
        cancelAction: this.$t('dialog.photo.errorExport.cancelAction'),
        confirmAction: this.$t('dialog.photo.errorExport.confirmAction')
      }
    }
  },
  components: {
    ImageColorPicker,
    PhotoSetScopable
  },
  computed: {
    ...mapGetters(['getShowImageColorPicker', 'getShowPhotoScopable'])
  },
  mounted: async function () {
    // let url = '/attributes?search={"type":[{"operator":"IN","value":["pim_catalog_image"]}]}'
    // On récupère depuis AKENEO la liste des champs de type images, en différenciant les champs scopables des champs non scopables.
    let done = false
    let url = '/attributes?limit=100'
    do {
      let { data } = await HTTP_PIM.get(url)
      if (data._embedded && data._embedded.items) {
        for (let i = 0; i < data._embedded.items.length; i++) {
          if (data._embedded.items[i].type === 'pim_catalog_image') {
            if (data._embedded.items[i].scopable === true) this.tPhotosScopable.push(data._embedded.items[i])
            else this.tPhotosNoScopable.push(data._embedded.items[i])
          }
        }
      }
      if (data._links && data._links.next) url = data._links.next.href
      else done = true
    } while (!done)

    // console.log('Photos scopable', this.tPhotosScopable)
    // console.log('Photos non scopable', this.tPhotosNoScopable)

    // On récupère depuis AKENEO la liste des filtres couleurs.
    let { data } = await HTTP_PIM.get('/attributes/CouleurFiltre/options?limit=100')
    this.tFilterColor = data._embedded.items
  },
  mixins: [toastMixin, dialogboxMixin],
  methods: {
    ...mapMutations({
      showImageColorPicker: 'SHOW_IMAGE_COLORPICKER_POPUP',
      showPhotoScopable: 'SHOW_PHOTO_SCOPABLE_POPUP'
    }),
    scopablePhotos: function (cab) {
      return this.tPhotosDropped.filter(file => {
        return (file.name.split('_')[0] === cab && this.tPhotosScopable.find(
          elt => this.getPhotoName(file) === elt.code
        ))
      })
    },
    noscopablePhotos: function (cab) {
      return this.tPhotosDropped.filter(file => {
        return (file.name.split('_')[0] === cab && this.tPhotosNoScopable.find(
          elt => this.getPhotoName(file) === elt.code
        ))
      })
    },
    async onDrop (event) {
      let globalInputError = ''

      // ---------- tableau contenant les photos ( nommage: CAB_Num_ChampAKENEO.jp(e)g ) ----------
      this.tPhotosDropped = [
        ...this.tPhotosDropped,
        ...Object.values(event.dataTransfer.files).filter(file => {
          // return new RegExp('^[0-9]{13}_[a-zA-Z0-9]+(_[0-9])?\\.jpe?g$').test(file.name)
          return new RegExp('^[0-9]{13}_[a-zA-Z0-9]+((_|\\(|\\s|-).*)?\\.jpe?g$').test(file.name)
        })
      ]

      // ---------- affichage des photos qui sont mal nommmés ----------
      let filenameError = []
      for (let file of event.dataTransfer.files) {
        // if (!new RegExp('^[0-9]{13}_[a-zA-Z0-9]+(_[0-9])?\\.jpe?g$').test(file.name)) {
        if (!new RegExp('^[0-9]{13}_[a-zA-Z0-9]+((_|\\(|\\s|-).*)?\\.jpe?g$').test(file.name)) {
          // console.log('check file name error', file.name)
          filenameError = [...filenameError, file.name]
        }
      }
      if (filenameError.length > 0) {
        globalInputError += this.$t('photo.inputErrors.name', { photosName: '<br><i>' + filenameError.join('<br>') + '</i><br><br>' })
      }

      // ---------- suppression des doublons photos ----------
      this.tPhotosDropped = [
        ...new Map(
          this.tPhotosDropped.map(item => [item['name'], item])
        ).values()
      ]
      // this.tPhotosDropped = [...new Set(this.tPhotosDropped)]
      // console.log('Photos déposées', this.tPhotosDropped)

      // ---------- tableau contenant les cab ----------
      this.tBarCod = this.tPhotosDropped.reduce((unique, item) => {
        let cab = item.name.split('_')[0]
        return unique.includes(cab) ? unique : [...unique, cab]
      }, [])

      // ---------- liste des champs photos présents dans AKENEO ----------
      let tPimPhotoFields = [...this.tPhotosScopable, ...this.tPhotosNoScopable]
      let pimPhotoFields = tPimPhotoFields.reduce((unique, item) => {
        let code = item.code
        return unique.includes(code) ? unique : unique.concat(code, ',')
      }, '')
      // console.log('Liste des champs images AKENEO ', pimPhotoFields)

      // ---------- on vérifie dans le nommage des images la présence d'un nom de champ image existant dans AKENEO ----------
      let fieldsUnknown = []
      for (let photo of this.tPhotosDropped) {
        /* if (!pimPhotoFields.includes(photo.name.split('_')[1].split('.')[0])) {
          fieldsUnknown = [...fieldsUnknown, photo.name]
        } */
        let pimPhotoFieldsFromPhotoFile = photo.name.match(new RegExp('^[0-9]{13}_([a-zA-Z0-9]+)((_|\\(|\\s|-).*)?\\.jpe?g$'))
        if (pimPhotoFieldsFromPhotoFile !== null) {
          if (!pimPhotoFields.includes(pimPhotoFieldsFromPhotoFile[1])) {
            fieldsUnknown = [...fieldsUnknown, photo.name]
          }
        } else fieldsUnknown = [...fieldsUnknown, photo.name]
      }

      if (fieldsUnknown.length > 0) {
        this.tPhotosDropped = this.tPhotosDropped.filter(file => !fieldsUnknown.includes(file.name))
        globalInputError += this.$t('photo.inputErrors.akeneoFields', { akeneoFields: '<br><i>' + fieldsUnknown.join('<br>') + '</i><br><br>' })
      }

      // console.log('Codes Barres detectées dans les photos', this.tBarCod)

      // ---------- parfois on perd la connexion avec AKENEO, dans ce cas il faut raffraichir la page ----------
      try {
        await HTTP_PIM.get()
      } catch (err) {
        // console.log('err', err.message)
        alert('Problème réseau, veuillez raffraichir votre écran')
      }

      // ---------- on verifie si les CAB inclus dans le nom des images existent dans AKENEO ----------
      this.tBarCodToCheck = [...this.tBarCod]
      this.tBarCod = []
      let cabUnknown = ''
      for (let cab of this.tBarCodToCheck) {
        let cabErr = true
        let eanCode = ''
        try {
          await HTTP_PIM.get(`/products/${cab}`)
          this.tBarCod = [...this.tBarCod, cab]
        } catch (err) {
          // ---------- si le CAB est inexistant, on verifie si ça ne serait pas un code EAN ----------
          if (!cab.startsWith('100000')) {
            try {
              let { data } = await HTTP_PIM.get(`/products?search={"ReferenceSecondaire":[{"operator":"=","value":"${cab}"}]}`)
              if (data._embedded && data._embedded.items && data._embedded.items.length === 1) {
                cabErr = false
                eanCode = data._embedded.items[0].identifier
                this.tEanCode[cab] = eanCode
              }
            } catch (e) {}
          }

          if (cabErr) {
            // console.log('CAB inexistant dans le PIM', cab)
            if (cabUnknown !== '') cabUnknown += ','
            cabUnknown += cab

            this.tPhotosDropped = this.tPhotosDropped.filter(file => !file.name.startsWith(cab))
          }
        }

        if (!cabErr && eanCode !== '') {
          this.tBarCod = [...this.tBarCod, cab]
        }
      }
      if (cabUnknown !== '') {
        globalInputError += this.$t('photo.inputErrors.cab', { cab: '<br><i>' + cabUnknown.split(',').join('<br>') + '</i><br><br>' })
      }

      // --- On effectue un tri alphanumerique sur le nom des images ---
      this.tPhotosDropped.sort(function (a, b) {
        console.log(a.name,b.name)
        return a.name.localeCompare(b.name, undefined, { numeric: true })
      })

      // ---------- On récupère les informations des articles dont les codes barres sont présents dans le nom des images à traiter ----------
      let i = 0
      for (let cab of this.tBarCod) {
	let cabToDisplay

        if (!cab.startsWith('100000')) cabToDisplay = this.tEanCode[cab]
        else cabToDisplay = cab

	// --- Dans le cas où dans le code barre interne il y a un code ean (quelques très vieilles références du temps de Columbus) ---
	if (cabToDisplay === undefined) {
           cabToDisplay = cab
	   this.tEanCode[cab] = cab 
	}

	const { data, data: { values } } = await HTTP_PIM.get(`/products/${cabToDisplay}`)

        this.tArticles[i] = {}
        this.tArticles[i]['filterColorCode'] = (values.CouleurFiltre !== undefined) ? values.CouleurFiltre[0].data : ''
        this.tArticles[i]['supplierColorCode'] = values.CouleurFournisseur[0].data
        this.tArticles[i]['hexaColorCode'] = (values.CouleurHexa !== undefined) ? values.CouleurHexa[0].data : ''
        this.tArticles[i]['reference'] = data.parent
        this.tArticles[i]['brand'] = (values.Marque !== undefined) ? values.Marque[0].data : ''

        // ------------------------------ essai pour gestion des images de campagne ----------------------------
        for (let gi = 1; gi <= 15; gi++) {
          // eslint-disable-next-line no-eval
          eval('if (values.Galerie' + gi + 'Photo !== undefined) this.tArticles[i]["Galerie' + gi + 'Photo"] = values.Galerie' + gi + 'Photo')
        }

        const { data: { labels: supplierColor } } = await HTTP_PIM.get(`/attributes/CouleurFournisseur/options/${this.tArticles[i]['supplierColorCode']}`)
        this.tArticles[i]['supplierColorName'] = (supplierColor !== undefined) ? supplierColor.fr_FR : ''
        const { data: { labels: filterColor } } = await HTTP_PIM.get(`/attributes/CouleurFiltre/options/${this.tArticles[i]['filterColorCode']}`)
        this.tArticles[i]['filterColorName'] = (filterColor !== undefined) ? filterColor.fr_FR : ''
        if (!this.tFilterColorSelected[i]) { this.tFilterColorSelected[i] = this.tArticles[i]['filterColorCode'] }
        if (!this.tHexaColorCode[i]) { this.tHexaColorCode[i] = this.tArticles[i]['hexaColorCode'] }

        if (data.parent.split('_').length === 1) { this.tArticles[i]['level'] = 'products' } else this.tArticles[i]['level'] = 'product-models'
        i++
      }
      console.log('Articles récupérés depuis Akeneo', this.tArticles)

      if (this.tArticles.length > 0) {
        if (this.previousView === -1) this.currentView = 0
        else this.currentView = this.previousView

        // ---------- Gestion de la barre d'outils ----------
        let iconList = []
        iconList.push({ svg: 'icon-trash', fn: this.deleteBarCode })
        iconList.push({ svg: 'icon-upload3', fn: this.onDropAdditionalPhotos })
        if (this.tBarCod.length > 1) {
          if (this.currentView > 0) { iconList.push({ svg: 'icon-arrow-left', fn: this.onPreviousArticle }) }
          if (this.currentView < this.tBarCod.length - 1) { iconList.push({ svg: 'icon-arrow-right', fn: this.onNextArticle }) }
        }
        this.$store.commit('subheader/UPDATE_ICONS', iconList)
      }

      // ---------- Affichage des erreurs détectées s'il y a lieu ----------
      if (globalInputError !== '') {
        this.dialogBoxInputErrors.content = globalInputError
        await this.msgbox(this.dialogBoxInputErrors)
      }
    },
    createPhotoUrl (item) {
      // console.log(item)
      return URL.createObjectURL(item)
    },
    onDropAdditionalPhotos () {
      this.previousView = this.currentView
      this.currentView = -1

      this.$store.commit('subheader/UPDATE_ICONS', [
        {
          svg: 'icon-camera',
          fn: this.onCurrentArticle
        }
      ])
    },
    onCurrentArticle () {
      this.currentView = this.previousView

      let iconList = []
      iconList.push({ svg: 'icon-trash', fn: this.deleteBarCode })
      iconList.push({ svg: 'icon-upload3', fn: this.onDropAdditionalPhotos })
      if (this.tBarCod.length > 1) {
        if (this.currentView > 0) { iconList.push({ svg: 'icon-arrow-left', fn: this.onPreviousArticle }) }
        if (this.currentView < this.tBarCod.length - 1) { iconList.push({ svg: 'icon-arrow-right', fn: this.onNextArticle }) }
      }
      this.$store.commit('subheader/UPDATE_ICONS', iconList)
    },
    onPreviousArticle () {
      if (this.currentView > 0) this.currentView -= 1

      let iconList = []
      iconList.push({ svg: 'icon-trash', fn: this.deleteBarCode })
      iconList.push({ svg: 'icon-upload3', fn: this.onDropAdditionalPhotos })
      if (this.currentView > 0) {
        iconList.push({ svg: 'icon-arrow-left', fn: this.onPreviousArticle })
        if (this.tBarCod.length > 1) { iconList.push({ svg: 'icon-arrow-right', fn: this.onNextArticle }) }
      } else if (this.tBarCod.length > 1) { iconList.push({ svg: 'icon-arrow-right', fn: this.onNextArticle }) }

      this.$store.commit('subheader/UPDATE_ICONS', iconList)
    },
    onNextArticle () {
      if (this.currentView < this.tBarCod.length - 1) this.currentView += 1

      let iconList = []
      iconList.push({ svg: 'icon-trash', fn: this.deleteBarCode })
      iconList.push({ svg: 'icon-upload3', fn: this.onDropAdditionalPhotos })
      if (this.tBarCod.length > 1) { iconList.push({ svg: 'icon-arrow-left', fn: this.onPreviousArticle }) }
      if (this.currentView < this.tBarCod.length - 1) { iconList.push({ svg: 'icon-arrow-right', fn: this.onNextArticle }) }

      this.$store.commit('subheader/UPDATE_ICONS', iconList)
    },
    getHexaColorCode (index) {
      if (!this.tHexaColorCode[index]) {
        this.tHexaColorCode[index] = this.tArticles[this.currentView]['hexaColorCode']
      }
      return this.tHexaColorCode[index]
    },
    getPhotoName (photo) {
      return photo.name.match(new RegExp('^[0-9]{13}_([a-zA-Z0-9]+)((_|\\(|\\s|-).*)?\\.jpe?g$'))[1]
      // return photo.name.split('_')[1].replace(/\.[^/.]+$/, '')
    },
    async deletePhoto (photo) {
      try {
        const ret = await this.msgbox(this.dialogBoxDelete)
        if (ret === 'confirm') {
          this.sendSuccessToast(this.$t('feedback-ok.photo.delete', { name: photo.name }))
          this.tPhotosDropped = this.tPhotosDropped.filter(file => file.name !== photo.name)
        }
      } catch (error) {
        console.log(error)
      }
    },
    /*async shiftPhotosToAkeneo (identifier, cabToExport) {
      console.log('identifier:', identifier)
      console.log('cabToExport:', cabToExport)

      if (this.tArticles[this.currentView]['Galerie10Photo'] !== undefined) {
        console.log('Erreur Presence image en galerie 10')
      } else {
        for (let iii = 9; iii > 0; iii--) {
          if (this.tArticles[this.currentView]['Galerie' + iii + 'Photo'] !== undefined) {
            // console.log('Recopie image galerie ' + iii + ' en image galerie ' + (iii + 1))

            for (let mediaFile of this.tArticles[this.currentView]['Galerie' + iii + 'Photo']) {
              let mediaBinaryFile
              try {
                mediaBinaryFile = await HTTP_PIM_IMG.get(`/media-files/${mediaFile.data}/download`)
              } catch (err) {
                console.log('ERROR: ', err)
              }

              let dataJSON = JSON.stringify({
                identifier: identifier,
                attribute: 'Galerie' + (iii + 1) + 'Photo',
                scope: mediaFile.scope,
                locale: null
              })

              let dataF = new FormData()
              dataF.append('file', new Blob([mediaBinaryFile.data]), cabToExport + '_Galerie' + (iii + 1) + 'Photo.jpg')
              dataF.append('product', dataJSON)

              try {
                await HTTP_PIM_IMG.post('media-files', dataF)
                const { data, data: { values } } = await HTTP_PIM.get(`/products/${cabToExport}`)

                // eslint-disable-next-line no-eval
                eval('if (values.Galerie' + (iii + 1) + 'Photo !== undefined) this.tArticles[this.currentView]["Galerie' + (iii + 1) + 'Photo"] = values.Galerie' + (iii + 1) + 'Photo')
              } catch (err) {
                console.log('ERROR: ', err)
              }
            }
          }
        }
      }
    },*/
    async exportPhotosToAkeneo (photos) {
      this.tErrPhotosUploadedToAkeneo = []
      let siteList
      let cabToExport

      if (!this.tBarCod[this.currentView].startsWith('100000')) cabToExport = this.tEanCode[this.tBarCod[this.currentView]]
      else cabToExport = this.tBarCod[this.currentView]

      // console.log('Photo: ', photo.name)
      // console.log('Article: ', this.tArticles[this.currentView])
      let bProductField = false

      let identifier
      if (this.tArticles[this.currentView]['level'] === 'products') { identifier = cabToExport } else identifier = this.tArticles[this.currentView]['reference']

      for (let photo of photos) {
        if (this.tArticles[this.currentView][this.getPhotoName(photo)] !== undefined) {
          const ret = await this.msgbox(this.dialogBoxOverwrite)
          /*if (ret !== 'confirm') {
            this.tArticles[this.currentView][this.getPhotoName(photo) + '_EXOPERA'] = 'insert'
            await this.shiftPhotosToAkeneo(identifier, cabToExport)
          }*/
        }

        if (this.productFields.includes(this.getPhotoName(photo))) {
          bProductField = true
          if (identifier.split('_').length === 2) identifier = identifier.split('_')[0]
          else identifier = this.tArticles[this.currentView]['reference']
        }

        if (photo.scope !== true) {
          let dataJSON
          if (this.tArticles[this.currentView]['level'] === 'products' && !bProductField) {
            dataJSON = JSON.stringify({
              identifier: identifier,
              attribute: this.getPhotoName(photo),
              scope: null,
              locale: null
            })
          } else {
            dataJSON = JSON.stringify({
              code: identifier,
              attribute: this.getPhotoName(photo),
              scope: null,
              locale: null
            })
          }

          let dataF = new FormData()
          dataF.append('file', photo, cabToExport + '_' + this.getPhotoName(photo) + '.jpg')
          if (this.tArticles[this.currentView]['level'] === 'products' && !bProductField) dataF.append('product', dataJSON)
          else dataF.append('product_model', dataJSON)
          // console.log('dataJSON: ', dataJSON)

          try {
            // let ret =
            await HTTP_PIM_IMG.post('media-files', dataF)
            // console.log('retour:', ret)
          } catch (err) {
            // console.log('err upload image', err)
            this.tErrPhotosUploadedToAkeneo = [...this.tErrPhotosUploadedToAkeneo, photo.name]
          }
        } else {
          if (photo.siteList !== undefined) siteList = photo.siteList
          else {
            siteList = this.siteList
            if (this.tArticles[this.currentView]['brand'] === '742') siteList[3].checked = true // Woomen
            if (this.tArticles[this.currentView]['brand'] === '737') siteList[4].checked = true // Cameleon
            if (this.tArticles[this.currentView]['brand'] === '731') siteList[5].checked = true // Etrier
          }

          for (let i = 0; i < siteList.length; i++) {
            if (siteList[i].checked === true) {
              // console.log('Site:', siteList[i].site, ' Code:', siteList[i].id)

	      // --- Si on coche marque propre, on envoie uniquement les photos sur le canal de la marque propre ---
	      if (this.marquePropreChecked && (i < 3)) continue
             
 	      // --- Si on coche edisac, on envoie uniquement les photos sur les canaux edisac ---
	      if (this.edisacChecked && (i > 2)) continue

	      let dataJSON
              if (this.tArticles[this.currentView]['level'] === 'products' && !bProductField) {
                dataJSON = JSON.stringify({
                  identifier: identifier,
                  attribute: this.getPhotoName(photo),
                  scope: siteList[i].id,
                  locale: null
                })
              } else {
                dataJSON = JSON.stringify({
                  code: identifier,
                  attribute: this.getPhotoName(photo),
                  scope: siteList[i].id,
                  locale: null
                })
              }

              let dataF = new FormData()
              dataF.append('file', photo, cabToExport + '_' + this.getPhotoName(photo) + '.jpg')
              if (this.tArticles[this.currentView]['level'] === 'products' && !bProductField) dataF.append('product', dataJSON)
              else dataF.append('product_model', dataJSON)
              // console.log('dataJSON: ', dataJSON)

              try {
                // let ret =
                await HTTP_PIM_IMG.post('media-files', dataF)
                // console.log('retour:', ret)
              } catch (err) {
                // console.log('err upload image 2', err)
                this.tErrPhotosUploadedToAkeneo = [...this.tErrPhotosUploadedToAkeneo, photo.name]
              }

              // Si c'est la photo galerie 2 on la recopie dans le champ GalerieVignette afin que AKENEO puisse l'utiliser comme vignette produit
              if ( this.getPhotoName(photo) === 'Galerie2Photo' && siteList[i].id === 'COM') {

                let dataJSON_Vignette
                if (this.tArticles[this.currentView]['level'] === 'products' && !bProductField) {
                  dataJSON_Vignette = JSON.stringify({
                    identifier: identifier,
                    attribute: 'GalerieMiniature',
                    scope: null,
                    locale: null
                  })
                } else {
                  dataJSON_Vignette = JSON.stringify({
                    code: identifier,
                    attribute: 'GalerieMiniature',
                    scope: null,
                    locale: null
                  })
                }

                let dataF_Vignette = new FormData()
                dataF_Vignette.append('file', photo, cabToExport + '_' + this.getPhotoName(photo) + '.jpg')
                if (this.tArticles[this.currentView]['level'] === 'products' && !bProductField) dataF_Vignette.append('product', dataJSON_Vignette)
                else dataF_Vignette.append('product_model', dataJSON_Vignette)

                try {
                  await HTTP_PIM_IMG.post('media-files', dataF_Vignette)
                } catch (err) {
                  this.tErrPhotosUploadedToAkeneo = [...this.tErrPhotosUploadedToAkeneo, photo.name]
                }

              }
            }
          }
        }
      }
    },
    async exportDataToAkeneo () {
      let cabToExport
      if (!this.tBarCod[this.currentView].startsWith('100000')) cabToExport = this.tEanCode[this.tBarCod[this.currentView]]
      else cabToExport = this.tBarCod[this.currentView]

      let patchUrl = ''
      if (this.tArticles[this.currentView]['reference'].split('_').length === 1) patchUrl = `/products/${cabToExport}`
      else patchUrl = `/product-models/${this.tArticles[this.currentView]['reference']}`

      try {
        /* let ret = */ await HTTP_PIM.patch(
          patchUrl,
          JSON.stringify({
            values: {
              CouleurFiltre: [
                {
                  data: this.tFilterColorSelected[this.currentView],
                  locale: null,
                  scope: null
                }
              ],
              CouleurHexa: [
                {
                  data: this.tHexaColorCode[this.currentView],
                  locale: null,
                  scope: null
                }
              ]
            }
          })
        )
        // console.log('exportDataToAkeneo ret ', ret)
      } catch (err) {
        this.errColorUploaded = true
      }
    },
    async exportToAkeneo () {
      let barcode = this.tBarCod[this.currentView]
      this.sendSuccessToast(this.$t('feedback-ok.photo.exportInProgress', { barcode }))

      this.errColorUploaded = false
      let globalOutputError = ''

      await this.exportDataToAkeneo()
      if (this.errColorUploaded) globalOutputError += this.$t('photo.outputErrors.colorFilter') + '<br><br>'

      let scopablePhotos = this.scopablePhotos(this.tBarCod[this.currentView])
      for (let photo of scopablePhotos) photo.scope = true
      // console.log('photos scopable', scopablePhotos)

      let noscopablePhotos = this.noscopablePhotos(this.tBarCod[this.currentView])
      for (let photo of noscopablePhotos) photo.scope = false
      // console.log('photos noscopable', noscopablePhotos)

      // console.log('photos', [...scopablePhotos, ...noscopablePhotos])
      await this.exportPhotosToAkeneo([...scopablePhotos, ...noscopablePhotos])
      this.tErrPhotosUploadedToAkeneo = [...new Set(this.tErrPhotosUploadedToAkeneo)]
      if (this.tErrPhotosUploadedToAkeneo.length > 0) {
        globalOutputError += this.$t('photo.outputErrors.export', { photos: '<br><i>' + this.tErrPhotosUploadedToAkeneo.join('<br>') + '</i><br><br>' })
      } else {
        let barcode = this.tBarCod[this.currentView]
        this.sendSuccessToast(this.$t('feedback-ok.photo.exportAkeneo', { barcode }))
      }

      if (globalOutputError.length > 0) {
        this.dialogBoxOutputAkeneoErrors.content = globalOutputError
        await this.msgbox(this.dialogBoxOutputAkeneoErrors)
      }
    },
    async exportPhotosToExopera (photos) {
      this.tErrPhotosUploadedToExopera = []
      let data
      let cabToExport
      let siteList

      if (!this.tBarCod[this.currentView].startsWith('100000')) cabToExport = this.tEanCode[this.tBarCod[this.currentView]]
      else cabToExport = this.tBarCod[this.currentView]

      for (let photo of photos) {
        switch (this.getPhotoName(photo)) {
          case 'Atout1Image':
          case 'Atout2Image':
          case 'Atout3Image':
          case 'AtoutSpecialImage':
            data = new FormData()
            data.append('photo', photo, cabToExport + '_' + this.getPhotoName(photo) + '.jpg')
            try {
              /* let res = */ await HTTP_CLIENT.post(`pim/product/photo`, data,
                {
                  headers: { 'Content-Type': 'multipart/form-data' }
                })
              // console.log('exportPhotosToExopera', res)
            } catch (error) {
              // console.log('error', error)
              this.tErrPhotosUploadedToExopera = [...this.tErrPhotosUploadedToExopera, photo.name]
            }
            break

          case 'PhotoYoutube':
            data = new FormData()
            data.append('photo', photo, cabToExport + '_' + this.getPhotoName(photo) + '.jpg')
            try {
              /* let res = */ await HTTP_CLIENT.post(`pim/product/photoYoutube`, data,
                {
                  headers: { 'Content-Type': 'multipart/form-data' }
                })
              // console.log('exportPhotosYoutube', res)
            } catch (error) {
              // console.log('error', error)
              this.tErrPhotosUploadedToExopera = [...this.tErrPhotosUploadedToExopera, photo.name]
            }
            break

          case 'ExtraPhoto':
	    if (photo.siteList !== undefined) siteList = photo.siteList
            else siteList = this.siteList

            if (siteList[0].checked && !this.marquePropreChecked) { 
               data = new FormData()
               data.append('photo', photo, cabToExport + '_' + this.getPhotoName(photo) + '.jpg')
               try {
                 /* let res = */ await HTTP_CLIENT.post(`pim/product/photoExtra`, data,
                   {
                     headers: { 'Content-Type': 'multipart/form-data' }
                   })
                 // console.log('exportPhotosExtra', res)
               } catch (error) {
                 // console.log('error', error)
                 this.tErrPhotosUploadedToExopera = [...this.tErrPhotosUploadedToExopera, photo.name]
               }
	    }
            break

          case 'Galerie1Photo':
          case 'Galerie2Photo':
          case 'Galerie3Photo':
          case 'Galerie4Photo':
          case 'Galerie5Photo':
          case 'Galerie6Photo':
          case 'Galerie7Photo':
          case 'Galerie8Photo':
          case 'Galerie9Photo':
          case 'Galerie10Photo':
          case 'Galerie11Photo':
          case 'Galerie12Photo':
	  case 'Galerie13Photo':
	  case 'Galerie14Photo':
	  case 'Galerie15Photo':
	      if (photo.siteList !== undefined) siteList = photo.siteList
	      else siteList = this.siteList

	      if (siteList[0].checked && !this.marquePropreChecked) {
                 data = new FormData()
                 data.append('photo', photo, cabToExport + '_' + this.getPhotoName(photo) + '.jpg')

                 //if (this.tArticles[this.currentView][this.getPhotoName(photo) + '_EXOPERA'] !== undefined) data.append('insert', 'true')

                 try {
                   /* let res = */ await HTTP_CLIENT.post(`pim/product/photoGalerie`, data,
                     {
                       headers: { 'Content-Type': 'multipart/form-data' }
                     })
                   // console.log('exportPhotosGalerie', res)
                 } catch (error) {
                   // console.log('error', error)
                   this.tErrPhotosUploadedToExopera = [...this.tErrPhotosUploadedToExopera, photo.name]
                 }
	       }
               break

          case 'PhotoSiteMarque1':
            data = new FormData()
            data.append('photo', photo, cabToExport + '_' + this.getPhotoName(photo) + '.jpg')
            try {
              /* let res = */ await HTTP_CLIENT.post(`pim/product/photoSiteMarque`, data,
                {
                  headers: { 'Content-Type': 'multipart/form-data' }
                })
              // console.log('exportPhotoSiteMarque', res)
            } catch (error) {
              // console.log('error', error)
              this.tErrPhotosUploadedToExopera = [...this.tErrPhotosUploadedToExopera, photo.name]
            }
            break
        }
      }
    },
    async exportToExopera () {
      let globalOutputError = ''
      let cabToExport

      if (!this.tBarCod[this.currentView].startsWith('100000')) cabToExport = this.tEanCode[this.tBarCod[this.currentView]]
      else cabToExport = this.tBarCod[this.currentView]

      try {
        // let res =
        await HTTP_CLIENT.post(`pim/product`, JSON.stringify({
          barcode: cabToExport,
          colorcode: this.tHexaColorCode[this.currentView].slice(1),
          colorno: this.tFilterColorSelected[this.currentView]
        }))
        // console.log('exportToExopera', res)
      } catch (error) {
        // console.log('error', error)
        globalOutputError += this.$t('photo.outputErrors.colorFilter') + '<br><br>'
      }

      let scopablePhotos = this.scopablePhotos(this.tBarCod[this.currentView])
      let noscopablePhotos = this.noscopablePhotos(this.tBarCod[this.currentView])
      await this.exportPhotosToExopera([...scopablePhotos, ...noscopablePhotos])

      this.tErrPhotosUploadedToExopera = [...new Set(this.tErrPhotosUploadedToExopera)]
      if (this.tErrPhotosUploadedToExopera.length > 0) {
        globalOutputError += this.$t('photo.outputErrors.export', { photos: '<br><i>' + this.tErrPhotosUploadedToExopera.join('<br>') + '</i><br><br>' })
      } else {
        let barcode = this.tBarCod[this.currentView]
        this.sendSuccessToast(this.$t('feedback-ok.photo.exportExopera', { barcode }))
      }

      if (globalOutputError.length > 0) {
        this.dialogBoxOutputExoperaErrors.content = globalOutputError
        await this.msgbox(this.dialogBoxOutputExoperaErrors)
      }
    },
    async exportAll () {
      // console.log('Filtre couleur', this.tFilterColorSelected[this.currentView])
      // console.log('Code couleur', this.tHexaColorCode[this.currentView])
      if (this.tFilterColorSelected[this.currentView] != '' && this.tHexaColorCode[this.currentView] != '' ) {
        await this.exportToAkeneo()
        await this.exportToExopera()
      } else {
        await this.msgbox(this.dialogBoxColorsErrors)
      }
    },
    changeColor (color) {
      this.tHexaColorCode[this.currentView] = color
    },
    changeSites (photo) {
      for (let i = 0; i < this.tPhotosDropped.length; i++) {
        if (photo.name === this.tPhotosDropped[i].name) {
          this.tPhotosDropped[i] = photo
          break
        }
      }
    },
    async deleteBarCode () {
      try {
        const ret = await this.msgbox(this.dialogBoxDeleteBarCode)
        if (ret === 'confirm') {
          let barcode = this.tBarCod[this.currentView]
          this.sendSuccessToast(this.$t('feedback-ok.photo.barcode.delete', { barcode }))

          this.tPhotosDropped = this.tPhotosDropped.filter(file => file.name.split('_')[0] !== this.tBarCod[this.currentView])
          this.tBarCod = this.tBarCod.filter(item => item !== this.tBarCod[this.currentView])
          this.tArticles = this.tArticles.slice(0, this.currentView).concat(this.tArticles.slice(this.currentView + 1, this.tArticles.length))
          this.tHexaColorCode = this.tHexaColorCode.slice(0, this.currentView).concat(this.tHexaColorCode.slice(this.currentView + 1, this.tHexaColorCode.length))
          this.tFilterColorSelected = this.tFilterColorSelected.slice(0, this.currentView).concat(this.tFilterColorSelected.slice(this.currentView + 1, this.tFilterColorSelected.length))

          this.currentView = 0
          let iconList = []
          if (this.tBarCod.length === 0) {
            this.currentView = -1
          } else {
            iconList.push({ svg: 'icon-trash', fn: this.deleteBarCode })
            iconList.push({ svg: 'icon-upload3', fn: this.onDropAdditionalPhotos })
            if (this.tBarCod.length > 1) {
              iconList.push({ svg: 'icon-arrow-right', fn: this.onNextArticle })
            }
          }
          this.$store.commit('subheader/UPDATE_ICONS', iconList)
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created () {
    await this.$store.dispatch('subheader/ADD_ICON_TOOLBAR', [])
  },
  destroyed () {
    this.$store.commit('subheader/REMOVE_ICON_TOOLBAR')
  }
}
</script>
